import React from 'react';
import { Navigate } from 'react-router-dom';

// Composant pour protéger les routes selon les rôles
const ProtectedRoute = ({ user, children, allowedRoles, redirectTo = "/dashboard" }) => {
  if (!user) {
    return <Navigate to="/login" />;
  }
  
  if (!allowedRoles.includes(user.role)) {
    return <Navigate to={redirectTo} />;
  }
  
  return children;
};

export default ProtectedRoute;